import { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Flex, Box, Text } from 'rebass/styled-components'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { useLazyQuery } from '@apollo/client';
import { GET_FOOD_TRACKING, GET_HC_PATIENT_CALENDLY_EVENTS } from '../../graphql/queries';
import { ICalendlyEvent, IGetPatientCalendlyEventsInput, IGetPatientCalendlyEventsOutput } from '../../graphql/types/queries/appointment';
import moment from 'moment';
import { Skeleton } from '../../components/loadingSkeleton/Skeleton';
import SwitchSelector from 'react-switch-selector';
import Select, { components } from "react-select";
import { ReactSelectStyles } from '../../styles/ReactSelectStyles';
import { RbCircledChecked, RbCircledUnchecked } from '../../components/RadioButton';
import { useIsVisible } from '../../hooks/useIsVisible';
import { IFoodTracked, IGetFoodTrackingInput, IGetFoodTrackingOutput } from '../../graphql/types/queries/symptoms';

interface IAppointmentsProps {
  id: string
  isMinimized?: boolean
}
const ListContainer = styled(Flex)`
  width: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
  &.selected {
    display: none;
  }
`;
const Option = (props: any) => {
  return (
    <components.Option {...props}>
      <Flex alignItems={'center'}>
        {props.isSelected ? (
          <RbCircledChecked />
        ) : <RbCircledUnchecked />}

        <Text ml={2}>{props.children}</Text>
      </Flex>
    </components.Option>
  );
};

const iconStyle = {
  width: '20px',
  height: '20px',
  background: '#FFFFFF',
  border: '3px solid #BCFFEB',
  margin: '10px',
  boxShadow: 'initial'
}

const contentStyle = {
  background: '#F0F5FD',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
  borderRadius: '10px',
  padding: '12px 0px',
}
const contentStyleMinimized = {
  background: '#F0F5FD',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
  borderRadius: '10px',
  padding: '12px 0px',
  marginBottom: '12px'
}
const contentArrowStyle = {
  borderRight: '7px solid  #F0F5FD',
}

const SelectorLarge = styled(Flex)`
  display: none;
  @media screen and (min-width: 1740px) {
    display: initial;
  }
`

const SelectorSmall = styled(Flex)`
  display: none;
  @media screen and (max-width: 1739px) {
    display: initial;
  }
`

const GaugeGood = () => {
  return (
    <svg width="28" height="21.64" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.82512 4.00756C3.36497 5.51929 2.34239 7.88945 2.40253 11.2567C2.41239 11.8089 1.97275 12.2646 1.42055 12.2744C0.868352 12.2843 0.412711 11.8447 0.402849 11.2925C0.334912 7.48839 1.49717 4.57425 3.38658 2.6181C3.67288 2.3217 3.97418 2.04908 4.28818 1.80005L5.61929 3.29836C5.34116 3.51184 5.07562 3.74821 4.82512 4.00756Z" fill="#DA0000" />
      <path d="M20.0027 11.4631C20.003 12.0154 19.5556 12.4634 19.0033 12.4638C18.4511 12.4642 18.003 12.0168 18.0027 11.4645C18 7.43484 16.284 4.70049 14 3.24189L15.1452 1.59998C17.9521 3.42579 19.9995 6.76938 20.0027 11.4631Z" fill="#4ECB71" />
      <path d="M5 1.24635C6.51037 0.375636 8.21966 -0.0333308 9.92401 0.00211979C11.4412 0.0336781 12.9503 0.415583 14.321 1.13085L13.2279 2.81974C12.1664 2.29742 11.018 2.02531 9.88242 2.00169C8.63594 1.97576 7.40001 2.24729 6.29112 2.81974L5 1.24635Z" fill="#FFC700" />
      <path d="M9.02566 9.43273C7.73427 10.1157 7.59062 11.2569 8.12999 12.2901C8.66791 13.3237 9.68374 13.8563 10.9769 13.1744C12.2672 12.4932 22.1905 5.39994 21.9771 4.99039C21.7637 4.58085 10.3174 8.75119 9.02566 9.43273Z" fill="#757676" />
      <path d="M9.02566 9.43273C7.73427 10.1157 7.59062 11.2569 8.12999 12.2901C8.66791 13.3237 9.68374 13.8563 10.9769 13.1744C12.2672 12.4932 22.1905 5.39994 21.9771 4.99039C21.7637 4.58085 10.3174 8.75119 9.02566 9.43273Z" fill="#757676" />
      <path d="M9.02566 9.43273C7.73427 10.1157 7.59062 11.2569 8.12999 12.2901C8.66791 13.3237 9.68374 13.8563 10.9769 13.1744C12.2672 12.4932 22.1905 5.39994 21.9771 4.99039C21.7637 4.58085 10.3174 8.75119 9.02566 9.43273Z" stroke="rgb(240, 245, 253)" />
    </svg>
  )
}

const GaugeAverage = () => {
  return (<svg width="28" height="25.2" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.4251 7.00756C2.96494 8.51929 1.94237 10.8894 2.0025 14.2567C2.01237 14.8089 1.57272 15.2646 1.02052 15.2744C0.468328 15.2843 0.0126862 14.8447 0.00282452 14.2925C-0.0651124 10.4884 1.09715 7.57425 2.98656 5.6181C3.27285 5.3217 3.57416 5.04908 3.88816 4.80005L5.21926 6.29836C4.94113 6.51184 4.6756 6.74821 4.4251 7.00756Z" fill="#DA0000" />
    <path d="M19.6027 14.4631C19.603 15.0154 19.1556 15.4634 18.6033 15.4638C18.051 15.4642 17.603 15.0168 17.6027 14.4645C17.6 10.4348 15.884 7.70049 13.6 6.24189L14.7452 4.59998C17.552 6.42579 19.5995 9.76938 19.6027 14.4631Z" fill="#4ECB71" />
    <path d="M4.59998 4.24635C6.11035 3.37564 7.81964 2.96667 9.52398 3.00212C11.0412 3.03368 12.5503 3.41558 13.921 4.13085L12.8279 5.81974C11.7664 5.29742 10.618 5.02531 9.48239 5.00169C8.23591 4.97576 6.99999 5.24729 5.89109 5.81974L4.59998 4.24635Z" fill="#FFC700" />
    <path d="M7.4621 14.4391C7.44948 15.8999 8.38534 16.5685 9.55077 16.5849C10.7158 16.6026 11.6671 15.9619 11.6816 14.5C11.6952 13.041 10.1688 0.939081 9.70704 0.932251C9.24529 0.92542 7.47615 12.9787 7.4621 14.4391Z" fill="#757676" />
    <path d="M7.4621 14.4391C7.44948 15.8999 8.38534 16.5685 9.55077 16.5849C10.7158 16.6026 11.6671 15.9619 11.6816 14.5C11.6952 13.041 10.1688 0.939081 9.70704 0.932251C9.24529 0.92542 7.47615 12.9787 7.4621 14.4391Z" fill="#757676" />
    <path d="M7.4621 14.4391C7.44948 15.8999 8.38534 16.5685 9.55077 16.5849C10.7158 16.6026 11.6671 15.9619 11.6816 14.5C11.6952 13.041 10.1688 0.939081 9.70704 0.932251C9.24529 0.92542 7.47615 12.9787 7.4621 14.4391Z" stroke="rgb(240, 245, 253)" />
  </svg>
  )
}
const GaugeLow = () => {
  return (<svg width="28" height="17.81" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.4251 4.00756C4.96494 5.51929 3.94237 7.88945 4.0025 11.2567C4.01237 11.8089 3.57272 12.2646 3.02052 12.2744C2.46833 12.2843 2.01269 11.8447 2.00282 11.2925C1.93489 7.48839 3.09715 4.57425 4.98656 2.6181C5.27285 2.3217 5.57416 2.04908 5.88816 1.80005L7.21926 3.29836C6.94113 3.51184 6.6756 3.74821 6.4251 4.00756Z" fill="#DA0000" />
    <path d="M21.6027 11.4631C21.603 12.0154 21.1556 12.4634 20.6033 12.4638C20.051 12.4642 19.603 12.0168 19.6027 11.4645C19.6 7.43484 17.884 4.70049 15.6 3.24189L16.7452 1.59998C19.552 3.42579 21.5995 6.76938 21.6027 11.4631Z" fill="#4ECB71" />
    <path d="M6.59998 1.24635C8.11035 0.375636 9.81964 -0.0333308 11.524 0.00211979C13.0412 0.0336781 14.5503 0.415583 15.921 1.13085L14.8279 2.81974C13.7664 2.29742 12.618 2.02531 11.4824 2.00169C10.2359 1.97576 8.99999 2.24729 7.89109 2.81974L6.59998 1.24635Z" fill="#FFC700" />
    <path d="M11.2132 12.7828C12.5249 13.426 13.5325 12.8713 14.0512 11.8276C14.5711 10.7848 14.4047 9.64996 13.0929 9.00472C11.7833 8.36144 0.211511 4.504 0.00565955 4.91738C-0.200192 5.33076 9.90248 12.1386 11.2132 12.7828Z" fill="#757676" />
    <path d="M11.2132 12.7828C12.5249 13.426 13.5325 12.8713 14.0512 11.8276C14.5711 10.7848 14.4047 9.64996 13.0929 9.00472C11.7833 8.36144 0.211511 4.504 0.00565955 4.91738C-0.200192 5.33076 9.90248 12.1386 11.2132 12.7828Z" fill="#757676" />
    <path d="M11.2132 12.7828C12.5249 13.426 13.5325 12.8713 14.0512 11.8276C14.5711 10.7848 14.4047 9.64996 13.0929 9.00472C11.7833 8.36144 0.211511 4.504 0.00565955 4.91738C-0.200192 5.33076 9.90248 12.1386 11.2132 12.7828Z" stroke="rgb(240, 245, 253)" />
  </svg>
  )
}

const AppointmentDisplay = ({ data, isPast }: { data: IFoodTracked, isPast: boolean }) => {
  return (
    <Flex flexDirection={'column'} width='100%'>
      <Flex flexDirection={['column', 'row', 'row']}>
        <Flex flexDirection={['row', 'column', 'column']} width={['100%', '120px', '120px']} paddingX={['12px', 0, 0]} justifyContent={['flex-start', 'center', 'center']} alignItems='center'>
          <Flex flexDirection={'column'}>
            <Text fontWeight={400} fontSize='14px'>{`${moment(data.date, 'YYYY-MM-DD').format('MM/DD/YYYY')}`}</Text>
            <Text fontWeight={300} fontSize='12px'>{data.time}</Text>
          </Flex>
        </Flex>
        <Box style={{ height: '48px', background: '#E2E2E2', width: '1px' }} display={['none', 'initial', 'initial']} />
        <Flex mt={[2, 0, 0]} flexDirection={'column'} width={['100%', '180px', '180px']} paddingX={['12px', 0, 0]} justifyContent={['flex-start', 'center', 'center']} alignItems={['flex-start', 'center', 'center']}>
          <Flex flexDirection={'column'}>
            <Text fontWeight={300} color='rgba(52, 79, 122, 0.6)' fontSize='12px'>Food Category</Text>
            <Text fontWeight={300} fontSize='14px'>{data.foodCategory}</Text>
          </Flex>
        </Flex>
        <Box style={{ height: '48px', background: '#E2E2E2', width: '1px' }} display={['none', 'initial', 'initial']} />
        <Flex mt={[2, 0, 0]} flexDirection={'column'} flex={1} justifyContent={['flex-start', 'center', 'center']} alignItems='flex-start' paddingX={'12px'}>
          <Flex flexDirection={'column'}>
            <Text fontWeight={300} color='rgba(52, 79, 122, 0.6)' fontSize='12px'>Food Item</Text>
            <Text fontWeight={300} fontSize='14px'>{data.foodItem}</Text>
          </Flex>
        </Flex>
        <Box style={{ height: '48px', background: '#E2E2E2', width: '1px' }} display={['none', 'initial', 'initial']} />
        <Flex mt={[2, 0, 0]} flexDirection={'column'} width={['100%', '180px', '180px']} paddingX={['12px', 0, 0]} justifyContent={['flex-start', 'center', 'center']} alignItems={['flex-start', 'center', 'center']}>
          <Flex flexDirection={'column'}>
            {/* <Text fontWeight={300} color='rgba(52, 79, 122, 0.6)' fontSize='12px'>Felt</Text> */}
            {/* <Text fontWeight={300} fontSize='14px'>{data.rating ? data.rating < 20 ? 'very bad' : data.rating < 40 ? 'bad' : data.rating < 60 ? 'neutral' : data.rating < 80 ? 'good' : data.rating < 120 ? 'very good' : '' : ''}</Text>
            <Text fontWeight={300} fontSize='14px'>({!data.rating ? 'not rated' : data.rating < 100 ? data.rating : 100}/100)</Text> */}
            {data.rating ? (
              <>
                {data.rating < 40 ? <GaugeLow /> : data.rating < 60 ? <GaugeAverage /> : <GaugeGood />}
              </>
            ) : null}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

const AppointmentDisplayMinimized = ({ data, isPast }: { data: IFoodTracked, isPast: boolean }) => {
  return (
    <Flex flexDirection={'column'} width='100%'>
      <Flex flexDirection={['column']}>
        <Flex flexDirection={['row']} width={['100%']} paddingX={['12px']} justifyContent={['flex-start']} alignItems='center'>
          <Flex flexDirection={'column'}>
            <Text fontWeight={400} fontSize='14px'>{`${moment(data.date, 'YYYY-MM-DD').format('MM/DD/YYYY')}`}</Text>
            <Text fontWeight={300} fontSize='12px'>{data.time}</Text>
          </Flex>
        </Flex>
        <Box style={{ height: '48px', background: '#E2E2E2', width: '1px' }} display={['none']} />
        <Flex mt={[2]} flexDirection={'column'} width={['100%']} paddingX={['12px']} justifyContent={['flex-start']} alignItems={['flex-start']}>
          <Flex flexDirection={'column'}>
            <Text fontWeight={300} color='rgba(52, 79, 122, 0.6)' fontSize='12px'>Food Category</Text>
            <Text fontWeight={300} fontSize='14px'>{data.foodCategory}</Text>
          </Flex>
        </Flex>
        <Box style={{ height: '48px', background: '#E2E2E2', width: '1px' }} display={['none']} />
        <Flex mt={[2, 0, 0]} flexDirection={'column'} flex={1} justifyContent={['flex-start', 'center', 'center']} alignItems='flex-start' paddingX={'12px'}>
          <Flex flexDirection={'column'}>
            <Text fontWeight={300} color='rgba(52, 79, 122, 0.6)' fontSize='12px'>Food Item</Text>
            <Text fontWeight={300} fontSize='14px'>{data.foodItem}</Text>
          </Flex>
        </Flex>
        <Box style={{ height: '48px', background: '#E2E2E2', width: '1px' }} display={['none']} />
        <Flex mt={[2]} flexDirection={'column'} width={['100%']} paddingX={['12px']} justifyContent={['flex-start']} alignItems={['flex-start']}>
          <Flex flexDirection={'column'}>
            {/* <Text fontWeight={300} color='rgba(52, 79, 122, 0.6)' fontSize='12px'>Felt</Text>
            <Text fontWeight={300} fontSize='14px'>{data.rating ? data.rating < 20 ? 'very bad' : data.rating < 40 ? 'bad' : data.rating < 60 ? 'neutral' : data.rating < 80 ? 'good' : data.rating < 120 ? 'very good' : '' : ''}</Text>
            <Text fontWeight={300} fontSize='14px'>({!data.rating ? 'not rated' : data.rating < 100 ? data.rating : 100}/100)</Text> */}
            {data.rating ? (
              <>
                {data.rating < 40 ? <GaugeLow /> : data.rating < 60 ? <GaugeAverage /> : <GaugeGood />}
              </>
            ) : null}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

const AppointmentDisplayLoading = ({ isPast }: { isPast: boolean }) => {
  return (
    <Flex flexDirection={'column'} width='100%'>
      <Flex flexDirection={['column', 'row', 'row']}>
        <Flex flexDirection={'column'} width='120px' justifyContent={'center'} alignItems='center'>
          <Flex flexDirection={'column'}>
            <Text fontWeight={400} fontSize='14px'><Skeleton height={19} width={90} style={{ marginTop: '1px', marginBottom: '1px' }} /></Text>
            <Text fontWeight={300} fontSize='12px'><Skeleton height={16} width={100} style={{ marginTop: '1px', marginBottom: '1px' }} /></Text>
          </Flex>
        </Flex>
        <Box style={{ height: '48px', background: '#E2E2E2', width: '1px' }} />
        <Flex flexDirection={'column'} width='180px' justifyContent={'center'} alignItems='center'>
          <Flex flexDirection={'column'}>
            <Text fontWeight={300} color='rgba(52, 79, 122, 0.6)' fontSize='12px'><Skeleton height={16} width={112} style={{ marginTop: '1px', marginBottom: '1px' }} /></Text>
            <Text fontWeight={300} fontSize='14px'><Skeleton height={19} width={112} style={{ marginTop: '1px', marginBottom: '1px' }} /></Text>
          </Flex>
        </Flex>
        <Box style={{ height: '48px', background: '#E2E2E2', width: '1px' }} />
        <Flex flexDirection={'column'} flex={1} justifyContent={'center'} alignItems='flex-start' paddingX={'12px'}>
          <Flex flexDirection={'column'}>
            <Text fontWeight={300} color='rgba(52, 79, 122, 0.6)' fontSize='12px'><Skeleton height={16} width={75} style={{ marginTop: '1px', marginBottom: '1px' }} /></Text>
            <Text fontWeight={300} fontSize='14px'><Skeleton height={19} width={163} style={{ marginTop: '1px', marginBottom: '1px' }} /></Text>
          </Flex>
        </Flex>
        {!!isPast && (
          <Skeleton height={18} width={61} style={{ marginRight: '12px' }} />
        )}
      </Flex>
    </Flex>
  )
}

const options = [
  {
    label: 'Upcoming',
    value: 'upcoming',
    selectedBackgroundColor: "#BCFFEB",
  },
  {
    label: "Past",
    value: "past",
    selectedBackgroundColor: "#BCFFEB"
  },
];

const optionsMobile = [
  {
    label: 'Upcoming',
    value: 'upcoming',
    selectedBackgroundColor: "#BCFFEB",
  },
  {
    label: "Past",
    value: "past",
    selectedBackgroundColor: "#BCFFEB"
  },
];

export const FoodTracking: React.FC<IAppointmentsProps> = ({ id, isMinimized }) => {
  const [appointmentData, setAppointmentData] = useState<Array<IFoodTracked> | null>(null);
  const [isParsingData, setIsParsingData] = useState<boolean>(false);

  const ref = useRef<any>();
  const isVisible = useIsVisible(ref);

  const [load, { data, loading, error }] = useLazyQuery<IGetFoodTrackingOutput, IGetFoodTrackingInput>(GET_FOOD_TRACKING, {
    variables: {
      patientId: id
    }
  })

  useEffect(() => {
    if (!!isVisible) {
      load()
    }
  }, [isVisible])

  useEffect(() => {
    if (!!loading || !data?.hcGetFoodTracking) {
      setAppointmentData(null)

      return
    }
    setIsParsingData(true)

    let res: Array<IFoodTracked> = []

    for (let index = 0; index < data.hcGetFoodTracking.length; index++) {
      const element = data.hcGetFoodTracking[index];
      let local = ''
      if (element.time) {
        let stillUtc = moment.utc(element.time).toDate();
        local = moment(stillUtc).local().format('hh:mm:ss a');
      }
      res.push({
        ...element,
        time: local,
      })
    }

    let ordered = res.sort((a, b) => {
      if (moment(`${a.date} ${a.time}`, 'YYYY-MM-DD hh:mm:ss a').isBefore(moment(`${b.date} ${b.time}`, 'YYYY-MM-DD hh:mm:ss a'))) return 1

      return -1
    })

    setAppointmentData(ordered)
    setIsParsingData(false)

    return () => {

    }
  }, [data, loading]);


  return (
    <Flex ref={ref} flexDirection={'column'} width='100%' px={isMinimized ? '0' : '20px'} paddingY={'20px'}>
      <Flex flexDirection={'column'} style={{ width: '100%', flex: 'initial', overflow: 'hidden' }} paddingY={'12px'} mb={0}>

        <Flex style={{ overflowY: 'hidden' }}>
          {!!loading || !!isParsingData ? (
            <ListContainer>
              <VerticalTimeline layout='1-column' lineColor='#344F7A' >
                {[0, 1, 2, 3].map(x => {
                  return (
                    <VerticalTimelineElement
                      className="vertical-timeline-element--work"
                      contentStyle={contentStyle}
                      contentArrowStyle={contentArrowStyle}
                      iconStyle={iconStyle} key={`loadingCalendlyAppts${x}`}
                      style={{
                        margin: 0,
                        marginBottom: '12px',
                      }}
                    >
                      <AppointmentDisplayLoading isPast={true} />
                    </VerticalTimelineElement>)
                })}
              </VerticalTimeline>
            </ListContainer>
          ) : (
            <>
              <ListContainer>
                {appointmentData && appointmentData.length > 0 ? (
                  <>
                    <VerticalTimeline layout='1-column' lineColor='#344F7A' >
                      {(appointmentData).map(x => {
                        return (
                          <VerticalTimelineElement
                            className="vertical-timeline-element--work"
                            contentStyle={!isMinimized ? contentStyle : contentStyleMinimized}
                            contentArrowStyle={contentArrowStyle}
                            style={{
                              margin: 0,
                              marginBottom: '12px',
                            }}
                            iconStyle={iconStyle} key={x.id}
                          >
                            {!isMinimized ? <AppointmentDisplay isPast={true} data={x} /> : <AppointmentDisplayMinimized isPast={true} data={x} />}
                          </VerticalTimelineElement>)
                      })}
                    </VerticalTimeline>
                  </>
                ) : (
                  <Flex m={4} justifyContent='center' alignItems={'center'} width='100%'>
                    <Text textAlign='center'>No Food Tracked</Text>
                  </Flex>
                )}
              </ListContainer>
            </>
          )}
        </Flex>
      </Flex>
    </Flex>);
}